import '../sass/latest-news.scss';

(() => {
    const $blocks = document.querySelectorAll('.latest-news');

    $blocks?.forEach($block => {
        const $carousel = $block.querySelector('.latest-news__carousel');
        const $controlsPrevious = $block.querySelector('.latest-news__controls--previous');
        const $controlsNext = $block.querySelector('.latest-news__controls--next');

        const initCarousel = () => {
            if (!$carousel) return;

            const swiper = new Swiper($carousel, {
                slidesPerView: 'auto',
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    nextEl: $controlsNext,
                    prevEl: $controlsPrevious,
                },
            });

            swiper.on('slideChangeTransitionStart', e => {
                if (e.isBeginning) {
                    $controlsPrevious.classList.add('latest-news__controls--disabled');
                } else {
                    $controlsPrevious.classList.remove('latest-news__controls--disabled');
                }

                if (e.isEnd) {
                    $controlsNext.classList.add('latest-news__controls--disabled');
                } else {
                    $controlsNext.classList.remove('latest-news__controls--disabled');
                }
            });
        };

        initCarousel();
    });
})();
